import { get, post } from './fetch';

type NotificationType = {
  id : string,
  name : string
}

export const getNotificationTypes = () => {
  return get({ endpoint: 'api/NotificationType' });
};

export const getNotificationType = (id : number) => {
  return get({ endpoint: `api/NotificationType/${id}` });
};

export const updateNotificationType = (notificationType : NotificationType) => {
  return post({ endpoint: `api/NotificationType/${notificationType.id}`, body: notificationType });
};

export const createNotificationType = (notificationType : NotificationType) => {
  return post({ endpoint: 'api/NotificationType', body: notificationType });
};

export const getNotificationChannels = () => {
  return get({ endpoint: 'api/NotificationChannel' });
};